const $ = require('jquery');

const $root = $(".js-menu");
const $btn = $root.find(".js-menuBtn");
const $body = $root.find(".js-menuBody");
let isOpen = false;

module.exports = function () {
    init();
};

function init(){
    setClickEvent();
}

function setClickEvent(){
    $btn.on("click",()=>{
        toggle();
    });
}

function toggle(){
    if(isOpen){
        close();
    } else {
        open();
    }
}

function open(){
    $body.fadeIn(()=>isOpen = true);
}

function close(){
    $body.fadeOut(()=>isOpen = false);
}
